module.exports = __webpack_public_path__ + "static/img/dynamicUser.1125cf8d.png";